import React, { Component } from 'react';
import { Menu, Dropdown, Button } from 'antd';
import { connect } from 'react-redux';
import './DefaultLayout.scss'
import _ from 'lodash';
import logo from "../../images/logo-image.png";
import appStore from "../../images/button2.png";
import playStore from "../../images/button3.png";
import { Carousel } from 'antd';
import Electrician from "../../images/electrician.jpg";
import Carpenter from "../../images/carpenter.jpg";
import Plumber from "../../images/plumber.jpg";
import TeamImg1 from "../../images/team1.jpeg";
import TeamImg2 from "../../images/team2.jpeg";
import TeamImg3 from "../../images/team3.jpg";
import TeamImg4 from "../../images/profile4.png";
import Avatar from "../../images/img_avatar.png";
import AboutUsImage from "../../images/about-us-image.png";
import MobileImahe from "../../images/about-image.png";
import HomeCaregory from '../../modules/user/component/homeCaregory'
import { logout } from '../../modules/user/action/user.actions'
import Header from "./Header";

import { Link } from "react-router-dom";

/* eslint eqeqeq: 0 */
export class DefaultLayout extends Component {
  constructor() {
    super();
    this.deleteAccount = this.deleteAccount.bind(this);
    this.logout = this.logout.bind(this);
  }

  deleteAccount(e) {
    console.log("Deleting Account")
  }

  logout(e) {
    const { dispatch } = this.props;
    dispatch(logout())
    console.log("Logging out")
  }

  render() {
    const { user } = this.props

    return (
      <div>
        <Header></Header>

        <div className="image" id="home">
          <div className="container">
            <div className="banner-heading">
              {/* text here */}
            </div>
            <div className="banner-sub-heading">
              {/* text here */}
            </div>
            <div className="form-cantant-box">
              {/* <input
                className="location-box"
                type="text"
                placeholder="Enter Location"
              ></input> */}
              <div className="banner-text-heading">
                Search for a service</div>
              <input
                className="service-box"
                type="text"
                placeholder="Search for a service"
              ></input>
            </div>
            {/* <div className="service-txt">Search for a service</div> */}
          </div>
        </div>
        <div className="services-background">
          <div className="service-heading-txt">Frequently Used Services</div>
          <div className="service-heading-sub-txt">100% Hygiene | Sanitized Tools | Disposable Products</div>
          <HomeCaregory></HomeCaregory>
        </div>

        <div className="download-box-container">
          <div className="download-box">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-xs-12">
                <div className="download-heading-txt">DOWNLOAD OUR APP</div>
                <div className="download-sub-heading-txt">
                  tackle your to-do list wherever you are with our mobile app
                 </div>
              </div>
              <div className="col-sm-12 col-md-6 col-xs-12">
                <div className="download-right-container">
                  {/* <img src={appStore} className="download-logo" alt="" /> */}
                  <div className="link-container">
                    <div className="app-text">Bidfhire Partner</div>
                    <a href="https://play.google.com/store/apps/details?id=com.partner_bidfhire_V2">
                      <img src={playStore} title='Bidfhire Partner' className="download-logo-one" alt="Partner" />
                    </a>
                  </div>
                  <div className="link-container">
                    <div className="app-text">Bidfhire Customer</div>
                    <a href="https://play.google.com/store/apps/details?id=com.customer_bidfhire_V2">
                      <img src={playStore} title='Bidfhire Customer' className="download-logo-one" alt="Customer" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="about-container">
          <div className="service-image-container">
            <div className='row'>
              <div className="col-sm-12 col-md-6 col-xs-12">
                <div className="">
                  <img src={MobileImahe} className="about-image" alt="" />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-xs-12">
                <div className="about-right-container">
                  <div className="about-first-heading">Get the BidFire app link</div>
                  <div className="about-second-heading">
                    Enter your mobile number to receive the app download link
                    </div>
                  <div className="mobile-no-box">
                    <span className="country-code">
                      <img></img>
                      <span>+91</span>
                    </span>
                    <span className="">
                      <span data-icon=""></span>
                    </span>
                    <input className="mobile-input" maxlength="50" placeholder="Enter Mobile number" />
                    <button className="link-send-btn">Send</button>
                  </div>
                </div>
                <div className="packet-name-txt">Bidfhire in your pocket!</div>
                <div className="about-first-heading">200+ <span className="count-service-txt">Services are avalable</span></div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-heading-txt">Essentials</div>
        <div className="service-heading-sub-txt">Services to help you through these times</div>
        <div className="service-image-container">
          <div className="row">
            <div className="col-sm-12 col-md-4 col-lg-4 col-xs-12">
              <div>
                <img src={Electrician} className="service-image" alt="" />
                <div className="service-text">Electrician</div>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 col-xs-12">
              <div>
                <img src={Carpenter} className="service-image" alt="" />
                <div className="service-text">Carpenter</div>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 col-xs-12">
              <div>
                <img src={Plumber} className="service-image" alt="" />
                <div className="service-text">Plumber</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="about-container" id="about">
            <div className="about-container-containt">
              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  <div className="">
                    {/* <div className="about-us-image"></div> */}
                    <img src={AboutUsImage} className="about-us-image" alt="" />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  <div className="about-right-container">
                    <div className="about-first-heading">Who Are We?</div>
                    <div className="about-second-heading">BIDFHIRE is a subsidiary of MODI TECH-PARK</div>
                    <div className="about-second-heading">MODI TECH-PARK began its business venture as an authorized service provider to popular companies like INTEK,SPICE and as third party service provider to Lenovo, Blackberry,Xiaomi,
                    Coolpad,Fly Wincom, Zen and many other brands.</div>
                    <div className="about-second-heading">MODI TECH-PARK has rendered excellent services to customers to the satisfaction of concerned companies.</div>
                    <div className="about-second-heading">In addition to this, it is rendering excellent services to customers in Home appliances sector for the products of Paramount, Ecopure, Haier, Whirlpool, Prestige,Havells,Cello, V-guard, Luminous, Micro tech, Xiaomi, Oppo, Samsung etc.</div>
                    <div className="about-second-heading">At present MODI TECH-PARK is intiating a innovative way to provide  best quality services to customers at their door steps in their basic needs.</div>
                    <div className="more-btn">
                      <Link to="/aboutUs">View More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="work-container">
          <div className="work-container-containt">
            <div className="service-heading-txt">Our Team Members</div>
            <div className="service-heading-sub-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
            <div className="row">
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="team-member-box">
                  <img src={TeamImg1} className="team-member-image" alt="" />
                  <div className="team-member-name-txt">Arvind Ujjani</div>
                  <div className="profile-name-txt">Operation Manager.</div>
                  <div className="profile-desc-txt">Customer Service Operations  and marketing professional with constructive experience in Business Development, Client Engagement, Customer Relationship Management, Marketing, Customer services, Business Analysis </div>
                  <div className="our-team-more-btn">View More</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="team-member-box">
                  <img src={Avatar} className="team-member-image" alt="" />
                  <div className="team-member-name-txt">Veera</div>
                  <div className="profile-name-txt">Software Development</div>
                  <div className="profile-desc-txt">Sr. Software Engineer</div>
                  <div className="our-team-more-btn">View More</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="team-member-box">
                  <img src={Avatar} className="team-member-image" alt="" />
                  <div className="team-member-name-txt">Kamal</div>
                  <div className="profile-name-txt">UX/UI Development</div>
                  <div className="profile-desc-txt">UX/UI Engineer </div>
                  <div className="our-team-more-btn">View More</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="team-member-box">
                  <img src={Avatar} className="team-member-image" alt="" />
                  <div className="team-member-name-txt">Saurav</div>
                  <div className="profile-name-txt">Software Development</div>
                  <div className="profile-desc-txt">Sr. Software Engineer </div>
                  <div className="our-team-more-btn">View More</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Carousel>
          <div>
            <h1 className="customer-heading">Our Happy Customers</h1>
            <h1 className="client-review-box">
              <div className="">
                {/* <img src={TeamImg3} className="customer-member-image" alt="" /> */}
              </div>
              <div className="customer-name">Sharan</div>
              <div className="customer-desc-txt">" Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry."</div>
            </h1>
          </div>
          <div>
            <h1 className="customer-heading">Our Happy Customers</h1>
            <h1 className="client-review-box">
              <div className="">
                {/* <img src={TeamImg3} className="customer-member-image" alt="" /> */}
              </div>
              <div className="customer-name">Kiran</div>
              <div className="customer-desc-txt">" Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry."</div>
            </h1>
          </div>
          <div>
            <h1 className="customer-heading">Our Happy Customers</h1>
            <h1 className="client-review-box">
              <div className="">
                {/* <img src={TeamImg3} className="customer-member-image" alt="" /> */}
              </div>
              <div className="customer-name">Suresh</div>
              <div className="customer-desc-txt">" Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry."</div>
            </h1>
          </div>
          <div>
            <h1 className="customer-heading">Our Happy Customers</h1>
            <h1 className="client-review-box">
              <div className="">
                {/* <img src={TeamImg3} className="customer-member-image" alt="" /> */}
              </div>
              <div className="customer-name">Shankar</div>
              <div className="customer-desc-txt">" Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry."</div>
            </h1>
          </div>
        </Carousel>

        <div className="form-container" id="contact">
          <div className="row">
            <div className="col-sm-12 col-md-4 col-xs-12 contact-padding">
              <div className="contact-heading">CONTACT US</div>
              <h3 className="column-title">Address</h3>
              <p>
                Bidfhire , # FF 4, 
                {/* <br /> */}
                N. V Jajee Arcade, S B Collage road,
                {/* <br /> */}
                Sangameshwarnagar Gulbarga- 585102
                {/* <br /> */}
                <br />
                    Phone: +91 88841 96731
                  <br />
                    Email : info@bidfire.in
                  <br />{" "}
              </p>
            </div>
            <div className="col-sm-12 col-md-8 col-xs-12 contact-padding">
              <form
                id="main-contact-form"
                name="contact-form"
                method="post"
                action="#"
              >
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Name"
                    required=""
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    required=""
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder="Subject"
                    required=""
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required=""
                  ></textarea>
                </div>
                <button type="submit" className="form-footer-btn">
                  Send Message
              </button>
              </form>
            </div>
          </div>
        </div>

        <div className="footer-background">
          <div className="footer-background-box">
            <div className="footer-box1">
              <div className="company-logo"></div>
            </div>
            <div className="footer-box2">
              <div className="company-address">
                <div className="footer-heading">Support</div>
                <ul className="footer-links">
                  <li>
                    <a href="#about">About Us</a>

                  </li>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/privacyPolicy">Terms & Privacy</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-box3">
              <div className="company-address">
                <div className="footer-heading">Services</div>
                <ul className="footer-links">
                  <li>
                    <a href="">Computers & IT Services</a>
                  </li>
                  <li>
                    <a href="">Electronics & Home Appliances</a>
                  </li>
                  <li>
                    <a href="">Smartphone & Tablet Service</a>
                  </li>
                  <li>
                    <a href="">E-WASTE Management Service</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-box4">
              <div className="footer-social">
                <div className="footer-heading">Social</div>
                <a href="">
                  <div className="social-img1"></div>
                </a>
                <a href="">
                  <div className="social-img2"></div>
                </a>
                <a href="">
                  <div className="social-img3"></div>
                </a>
                <a href="">
                  <div className="social-img4"></div>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>

    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(
  mapStateToProps
)(DefaultLayout);
